module.exports = __webpack_public_path__ + "static/media/corner-up-right-alt.0c7c9e28.svg";